export const GITHUB_URL = "https://github.com/levysantiago";
export const LINKEDIN_URL = "https://www.linkedin.com/in/levysantiago";
